export default {"src":"/_next/static/media/downmenu.42ed7700.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};